import type { VoidFunctionComponent } from 'react';
import { BadgeColors, TooltipContent } from '../../../generic';
import TooltipBadge from '../../../generic/Badge/TooltipBadge';

type Props = {
  showTooltip?: boolean;
};

/**
 * Displays a Reachability badge.
 */
const ReachabilityBadge: VoidFunctionComponent<Props> = ({ showTooltip = true }) => (
  <TooltipBadge
    id="reachability-badge"
    tooltip={<TooltipContent>This vulnerability is reachable in at least one project.</TooltipContent>}
    color={BadgeColors.LightRed}
    showTooltip={showTooltip}
  >
    Reachability
  </TooltipBadge>
);

export default ReachabilityBadge;
